import {
    PocComponentFooter,
    PocComponentHeader,
    PocProgressSpinner,
    PocTypography,
} from 'commons/components/components-wrapper';
import { useAutoFocusField } from 'commons/hooks/use-auto-focus-field.hook';
import { t } from 'core/i18n/i18n';
import { TooltipedIconComponent } from '../tooltiped-icon';
import { WorkflowStyledComponent } from './workflow-overlay.style';
import { resolveAutofocusField } from './workflow-overlay.utils';

export interface WorkflowOverlayComponentProps extends React.PropsWithChildren {
    visible: boolean;
    loading?: boolean;
    headerTitle: string;
    footer?: React.ReactElement[];
    disableEscape?: boolean;
    onClose: VoidFunction;
    className?: string;
}

export const WorkflowOverlayComponent: React.FC<WorkflowOverlayComponentProps> = (props) => {
    const { children, visible, loading = false, headerTitle, footer, disableEscape = true, onClose, className } = props;
    const contentRef = useAutoFocusField<HTMLDivElement>({ loading, resolveTarget: resolveAutofocusField });

    return (
        <WorkflowStyledComponent
            visible={visible}
            closeIconProps={{ onclick: onClose }}
            noCloseIcon
            noAutoFocus
            disableEscapeKeydown={disableEscape}
            className={className}
            data-testid="workflow-overlay"
        >
            <PocComponentHeader slot="header">
                <TooltipedIconComponent
                    slot="prefix"
                    icon={'clear'}
                    tooltipText={t('commons.components.icon.close.tooltip')}
                    onClick={onClose}
                />
                <PocTypography>{headerTitle}</PocTypography>
            </PocComponentHeader>
            <div slot="content" ref={contentRef} className={loading ? 'loading' : ''}>
                {loading ? <PocProgressSpinner variant="primary" size="large" /> : children}
            </div>
            {footer ? (
                <PocComponentFooter slot="footer" separator>
                    <div slot="suffix" style={{ display: 'flex', alignItems: 'center', gap: '24px' }}>
                        {footer}
                    </div>
                </PocComponentFooter>
            ) : undefined}
        </WorkflowStyledComponent>
    );
};
